import React from "react";
import {
  useReactTable,
  getCoreRowModel,
  flexRender,
  createColumnHelper,
} from "@tanstack/react-table";

export default function DataTable({ data, issues = [] }) {
  const safeData = Array.isArray(data) ? data : [];

  const columnHelper = createColumnHelper();

  const columns = React.useMemo(() => {
    if (safeData.length === 0) return [];

    return Object.keys(safeData[0]).map((key) =>
      columnHelper.accessor(key, {
        header: () => key,
        cell: (info) => {
          const rowIndex = info.row.index;
          const colName = info.column.id;

          const issueHere = issues.find(
            (i) => i.row === rowIndex && i.col === colName
          );

          let value = info.getValue();
          if (
            issueHere &&
            issueHere.suggestion &&
            issueHere.suggestion !== "" &&
            issueHere.suggestion !== issueHere.original
          ) {
            value = issueHere.suggestion;
          }

          return (
            <span
              style={{
                fontWeight: issueHere ? "bold" : "normal",
                color: issueHere ? "#2e7d32" : "#333",
              }}
            >
              {String(value ?? "")}
            </span>
          );
        },
      })
    );
  }, [safeData, issues]);

  const table = useReactTable({
    data: safeData,
    columns,
    getCoreRowModel: getCoreRowModel(),
  });

  if (safeData.length === 0) {
    return <div>No data available</div>;
  }

  return (
    <div
      style={{
        maxHeight: "330px",
        overflowY: "auto",
        borderRadius: "12px",
        border: "1px solid #ddd",
        boxShadow: "0px 3px 8px rgba(0,0,0,0.06)",
        background: "white"
      }}
    >
      <table
        style={{
          width: "100%",
          borderCollapse: "collapse",
        }}
      >
        <thead style={{ background: "#f0f0f0", position: "sticky", top: 0, zIndex: 5 }}>
          {table.getHeaderGroups().map((headerGroup) => (
            <tr key={headerGroup.id}>
              {headerGroup.headers.map((header) => (
                <th
                  key={header.id}
                  style={{
                    padding: "10px",
                    borderBottom: "2px solid #ccc",
                    fontWeight: "600",
                    textAlign: "left",
                    fontSize: "14px",
                    letterSpacing: "0.3px",
                    background: "#f7f7f7",
                  }}
                >
                  {flexRender(header.column.columnDef.header, header.getContext())}
                </th>
              ))}
            </tr>
          ))}
        </thead>

        <tbody>
          {table.getRowModel().rows.map((row) => (
            <tr
              key={row.id}
              style={{
                backgroundColor: row.index % 2 === 0 ? "#ffffff" : "#fafafa",
              }}
            >
              {row.getVisibleCells().map((cell) => {
                const rowIndex = row.index;
                const colName = cell.column.id;
                const issueHere = issues.find(
                  (i) => i.row === rowIndex && i.col === colName
                );

                return (
                  <td
                    key={cell.id}
                    style={{
                      padding: "8px",
                      borderBottom: "1px solid #eee",
                      backgroundColor: issueHere ? "#fff5e6" : "transparent",
                      borderLeft: issueHere ? "3px solid #ff9800" : "3px solid transparent",
                      fontSize: "14px",
                    }}
                  >
                    {flexRender(cell.column.columnDef.cell, cell.getContext())}
                  </td>
                );
              })}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
